import { render } from "./OnboardingPage.vue?vue&type=template&id=552dbbd8&scoped=true"
import script from "./OnboardingPage.vue?vue&type=script&lang=js"
export * from "./OnboardingPage.vue?vue&type=script&lang=js"

import "./OnboardingPage.vue?vue&type=style&index=0&id=552dbbd8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-552dbbd8"]])

export default __exports__